import styles from './truckPreparationPDFPage.module.css'
import { PDFHeader } from '../../../../features/ui'
import { TruckPreparationPDFBlock, TruckPreparationPDFData } from './types'

type Props = {
    pageIndex: number
    pagesAmount: number
    data: TruckPreparationPDFData
    blocks: TruckPreparationPDFBlock[]
}

// Printable truck preparation of a roadmap, for the warehouse operators: the shipments in loading order with a
// box to tick each product
export const TruckPreparationPDFPage = (props: Props) => {
    const { pageIndex, pagesAmount, data, blocks } = props
    const isFirstPage = pageIndex === 0
    const isLastPage = pageIndex === pagesAmount - 1

    return (
        <div className={styles.container}>
            <div className={styles.body}>
                <PDFHeader />

                {isFirstPage && (<>
                    <div className={styles.row}>
                        <span className={styles.title}>
                            Preparación de Camión: Hoja de Ruta {data.roadmapCode}
                        </span>
                        <div className={styles.date}>
                            Fecha: {data.date}
                        </div>
                    </div>

                    <div className={`${styles.row} ${styles.alignStart}`}>
                        <div className={styles.infoSection}>
                            <span>Sucursal: {data.branch}</span>
                            <span>Vehículo: {data.vehicle}</span>
                        </div>
                        <div className={`${styles.infoSection} ${styles.rightSection}`}>
                            <span>Chofer: {data.driver}</span>
                            <span>Envíos: {data.shipments.length}</span>
                        </div>
                    </div>
                </>)}

                {blocks.map((block, blockIndex) => (
                    <div key={blockIndex} className={styles.block}>
                        <div className={styles.blockTitle}>
                            {block.title}{block.continued ? ' (continuación)' : ''}
                        </div>
                        {block.subtitle && (
                            <div className={styles.blockSubtitle}>{block.subtitle}</div>
                        )}
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th className={styles.checkColumn} />
                                    <th className={styles.productColumn}>Producto</th>
                                    <th className={styles.quantityColumn}>Cantidad</th>
                                </tr>
                            </thead>
                            <tbody>
                                {block.rows.map((row, rowIndex) => (
                                    <tr key={rowIndex}>
                                        <td className={styles.checkColumn}><div className={styles.checkBox} /></td>
                                        <td className={styles.productColumn}>{row.product}</td>
                                        <td className={styles.quantityColumn}>{row.quantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}

                <div className={styles.footer}>
                    {isLastPage && (
                        <div className={styles.signatures}>
                            <div className={styles.signature}>Preparó</div>
                            <div className={styles.signature}>Controló</div>
                            <div className={styles.signature}>Chofer</div>
                        </div>
                    )}
                    <div className={styles.pagination}>
                        {pageIndex + 1} / {pagesAmount}
                    </div>
                </div>
            </div>
        </div>
    )
}
